<template>
  <div>
    <div class="box">
      <section>
        <b-field label="Buscar usuario">
          <b-input v-model="searchQuery" placeholder="Buscar por nombre, email o sucursal"
                   @input="debouncedFetchUsers" />
        </b-field>

        <b-table
          :data="users"
          :paginated="false"
          :loading="loading"
          :mobile-cards="true"
        >
          <b-table-column field="clave" label="Clave" width="120" v-slot="props">{{ props.row.code }}</b-table-column>
          <b-table-column field="nombre" label="Nombre" v-slot="props">{{ props.row.name }}</b-table-column>
          <b-table-column field="sucursal" label="Sucursal Activa" v-slot="props">{{
              props.row.branch_office
            }}
          </b-table-column>
          <b-table-column field="email" label="Email" v-slot="props">{{ props.row.email }}</b-table-column>
          <b-table-column field="acciones" label="Acciones" width="200" v-slot="props">
            <div class="is-flex" style="gap: 8px">
              <b-tooltip label="Desbloquear usuario">
                <b-button v-if="props.row.blocked"
                          icon-right="lock"
                          size="is-small" type="is-warning" @click="confirmUnlock(props.row)"
                          v-slot="props">Desbloquear
                </b-button>
              </b-tooltip>
              <b-tooltip label="Cambiar contraseña">
                <b-button size="is-small" type="is-info" icon-right="key" @click="promptPasswordChange(props.row)"
                          v-slot="props">Cambiar
                  contraseña
                </b-button>
              </b-tooltip>
            </div>
          </b-table-column>
        </b-table>

        <b-pagination
          :total="total"
          :current.sync="page"
          :per-page="perPage"
          @change="fetchUsers"
          order="is-centered"
        />

        <!-- Modal: Confirmar desbloqueo -->
        <b-modal :active.sync="showUnlockModal" has-modal-card>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Confirmar desbloqueo</p>
            </header>
            <section class="modal-card-body">
              ¿Deseas desbloquear al usuario <strong>{{ selectedUser.name }}</strong>?
            </section>
            <footer class="modal-card-foot">
              <b-button type="is-success" @click="unlockUser">Sí, desbloquear</b-button>
              <b-button @click="showUnlockModal = false">Cancelar</b-button>
            </footer>
          </div>
        </b-modal>

        <!-- Modal: Cambiar contraseña -->
        <b-modal :active.sync="showPasswordModal" has-modal-card>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Cambiar contraseña</p>
            </header>
            <section class="modal-card-body">
              <b-field label="Nueva contraseña">
                <b-input type="password" v-model="newPassword" password-reveal />
              </b-field>
            </section>
            <footer class="modal-card-foot">
              <b-button type="is-primary" @click="changePassword">Guardar</b-button>
              <b-button @click="showPasswordModal = false">Cancelar</b-button>
            </footer>
          </div>
        </b-modal>
      </section>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  name: "Users",
  data() {
    return {
      users: [],
      loading: false,
      page: 1,
      perPage: 10,
      total: 0,
      searchQuery: "",
      selectedUser: {},
      showUnlockModal: false,
      showPasswordModal: false,
      newPassword: "",
      debouncedFetchUsers: null
    };
  },
  created() {
    this.debouncedFetchUsers = debounce(this.fetchUsers, 400);
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      this.$loader.show();
      this.$http.get(`/admin/users?page=${this.page}&per_page=${this.perPage}&search=${encodeURIComponent(this.searchQuery)}`).then(({ data }) => {
        this.users = data.data;
        this.total = data.meta.total;
      }).catch(errors => {
        this.$buefy.toast.open({ message: "Error al cargar usuarios", type: "is-danger" });
      }).finally(() => {
        this.$loader.hide();
      });
    },
    confirmUnlock(user) {
      this.selectedUser = user;
      this.showUnlockModal = true;
    },
    async unlockUser() {
      this.$loader.show();
      this.$http.post(`/admin/users/unlock`, {
        code: this.selectedUser.code,
      }).then(() => {
        this.$buefy.toast.open({ message: "Usuario desbloqueado", type: "is-success" });
        this.showUnlockModal = false;
        this.fetchUsers();
      }).catch(() => {
        this.$buefy.toast.open({ message: "No se pudo desbloquear", type: "is-danger" });
      }).finally(() => {
        this.$loader.hide();
        this.selectedUser = {};
      });
    },
    promptPasswordChange(user) {
      this.selectedUser = user;
      this.newPassword = "";
      this.showPasswordModal = true;
    },
    async changePassword() {
      this.$loader.show();
      this.$http.post(`/admin/user-password`, {
        username: this.selectedUser.code,
        password: this.newPassword
      }).then(() => {
        this.$buefy.toast.open({ message: "Contraseña cambiada", type: "is-success" });
        this.showPasswordModal = false;
        this.fetchUsers();
      }).catch(() => {
        this.$buefy.toast.open({ message: "Error al cambiar contraseña", type: "is-danger" });
      }).finally(() => {
        this.$loader.hide();
        this.selectedUser = {};
      });
    }
  }
};
</script>

<style scoped>

</style>
